import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetooutstationcabspackages() {



  const cardData =
  {
    keyword: 'Pune to Outstation Cabs Package',
    heading: 'Sanavi Travels: Pune to Outstation Cabs Package',
    headingDescription: 'Sanavi Travels offers Pune to Outstation Cabs Package, providing safe, comfortable, and reliable taxi services for families, corporate travelers, tourists, and group trips traveling from Pune to destinations across Maharashtra and India. Our fleet of well-maintained hatchbacks, sedans, SUVs, and luxury cabs ensures smooth rides, air-conditioned comfort, and ample luggage space for long-distance journeys. With professional chauffeurs, flexible one-way and round-trip cab packages, transparent pricing, and 24/7 booking support, our Pune to outstation cab services guarantee punctual, stress-free, and convenient travel. Choose Sanavi Travels for trusted outstation cab packages from Pune, delivering comfort, safety, and reliability for every journey.',

    top: 'Top Places to Visit in Pune Outstation  with Sanavi Travels',


"topPlaces": [
  {
    "title": "Lonavala",
    "description": "Lonavala is a popular hill station near Pune, known for its lush green hills, waterfalls, and pleasant climate. Key attractions include Bhushi Dam, Tiger’s Leap, Rajmachi Fort, and Karla Caves. The hill station is ideal for trekking, nature walks, and weekend getaways from Pune."
  },
  {
    "title": "Mahabaleshwar",
    "description": "Mahabaleshwar is a scenic hill station in the Western Ghats, famous for viewpoints like Arthur’s Seat, Elephant’s Head Point, and Bombay Point. Venna Lake, Mapro Garden, and Pratapgad Fort are major attractions. It is popular for strawberry farms, trekking, and panoramic valley views."
  },
  {
    "title": "Bhimashankar",
    "description": "Bhimashankar is a serene destination near Pune, famous for the Bhimashankar Jyotirlinga Temple and the Bhimashankar Wildlife Sanctuary. Visitors can enjoy trekking, Kushalgarh Waterfall, and exploring the Western Ghats’ rich flora and fauna. It is a perfect blend of spirituality and nature."
  },
  {
    "title": "Panchgani",
    "description": "Panchgani is a charming hill station known for Table Land, the second-longest mountain plateau in Asia. Popular attractions include Sydney Point, Parsi Point, and Lingmala Waterfall. The town is famous for its strawberry farms, scenic viewpoints, and peaceful environment, making it ideal for weekend trips."
  },
  {
    "title": "Lavasa",
    "description": "Lavasa is a planned hill city near Pune, known for its picturesque lakes, walking trails, and modern architecture. It offers boating, water sports, and leisure activities amidst scenic surroundings. Lavasa is popular for short getaways and family trips from Pune."
  },
  {
    "title": "Khandala",
    "description": "Khandala, adjacent to Lonavala, is a serene hill station with scenic viewpoints, lush valleys, and waterfalls. Popular spots include Duke’s Nose, Rajmachi Fort, and Tiger’s Leap. It is ideal for trekking, nature photography, and monsoon trips from Pune."
  },
  {
    "title": "Matheran",
    "description": "Matheran is a unique hill station with a vehicle-free environment, offering tranquility and natural beauty. Key attractions include Panorama Point, Louisa Point, Echo Point, and Charlotte Lake. Trekking, toy train rides, and serene viewpoints make it a perfect outstation escape."
  },
  {
    "title": "Alibaug",
    "description": "Alibaug is a coastal town near Pune, known for its beaches, forts, and water sports. Popular spots include Alibaug Beach, Kolaba Fort, and Kihim Beach. Alibaug is ideal for relaxing seaside getaways, weekend trips, and adventure activities from Pune."
  },
  {
    "title": "Nashik",
    "description": "Nashik is a historic city near Pune, famous for vineyards, temples, and the Godavari River. Key attractions include Trimbakeshwar Temple, Sula Vineyards, Pandavleni Caves, and Ramkund. It is popular for wine tours, spiritual visits, and heritage exploration."
  },
  {
    "title": "Igatpuri",
    "description": "Igatpuri is a serene hill station near Pune, known for its scenic landscapes, waterfalls, and Vipassana meditation center. Attractions include Bhatsa River Valley, Camel Valley, and Tringalwadi Fort. It is ideal for trekking, meditation retreats, and monsoon trips from Pune."
  }
]
,




"services": [
  {
    "name": "Pune to Outstation Cabs Package",
    "description": "Comprehensive cab packages for travel from Pune to outstation destinations, tailored for families, groups, and corporate travelers seeking comfort and convenience."
  },
  {
    "name": "Outstation Cab from Pune",
    "description": "Reliable cab services from Pune to nearby cities and towns, offering safe and punctual travel for all types of travelers."
  },
  {
    "name": "AC Outstation Cab Pune",
    "description": "Air-conditioned cabs for outstation travel, ensuring a cool and comfortable journey over long distances."
  },
  {
    "name": "Luxury Outstation Cab Pune",
    "description": "Premium cabs with extra comfort and amenities, ideal for travelers looking for a luxurious outstation experience."
  },
  {
    "name": "Family Outstation Cab Pune",
    "description": "Family-friendly outstation cabs with ample seating and luggage space for a smooth and enjoyable journey."
  },
  {
    "name": "Corporate Outstation Cab Pune",
    "description": "Professional cab services for corporate travel to outstation locations, with punctuality, safety, and convenience."
  },
  {
    "name": "Affordable Outstation Cab Pune",
    "description": "Budget-friendly outstation cabs offering comfort and reliability without exceeding your travel budget."
  },
  {
    "name": "Chauffeur Driven Outstation Cab",
    "description": "Experienced drivers handle navigation, traffic, and safety, ensuring a relaxed and hassle-free outstation trip."
  },
  {
    "name": "Best Outstation Cab Service Pune",
    "description": "High-quality outstation cab services with well-maintained vehicles and excellent customer support for a seamless travel experience."
  },
  {
    "name": "Pune Outstation Taxi",
    "description": "Convenient taxi service for outstation travel from Pune, suitable for individual travelers, families, and groups."
  },
  {
    "name": "Tourist Outstation Cab Pune",
    "description": "Cabs designed for sightseeing and tourist travel to outstation destinations, combining comfort with flexible itineraries."
  },
  {
    "name": "Long Distance Cab Pune",
    "description": "Cabs specifically suited for long-distance travel, ensuring comfort, safety, and reliability across extended trips."
  },
  {
    "name": "One Way Outstation Cab Pune",
    "description": "Flexible one-way cab service from Pune to outstation destinations, ideal for travelers needing direct and efficient transport."
  },
  {
    "name": "Round Trip Cab Pune",
    "description": "Round-trip cab services from Pune to outstation locations, perfect for return journeys with convenience and comfort."
  },
  {
    "name": "Online Cab Booking Pune",
    "description": "Book outstation cabs online from Pune with instant confirmation, easy payments, and a hassle-free booking experience."
  }
],
"tableData": [
  ["Pune to Outstation Cabs Package", "Outstation Cab from Pune"],
  ["AC Outstation Cab Pune", "Luxury Outstation Cab Pune"],
  ["Family Outstation Cab Pune", "Corporate Outstation Cab Pune"],
  ["Affordable Outstation Cab Pune", "Chauffeur Driven Outstation Cab"],
  ["Best Outstation Cab Service Pune", "Pune Outstation Taxi"],
  ["Tourist Outstation Cab Pune", "Long Distance Cab Pune"],
  ["One Way Outstation Cab Pune", "Round Trip Cab Pune"],
  ["Online Cab Booking Pune", "—"]
]
,


"whychoose": [
  {
    "WhyChooseheading": "Pune to Outstation Cabs Package with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels provides reliable and convenient Pune to outstation cab packages, perfect for business trips, family vacations, long-distance travel, and weekend getaways."
  },
  {
    "WhyChooseheading": "Comfortable and Well-Maintained Vehicles",
    "WhyChoosedescription": "Travel in spacious, air-conditioned, and regularly serviced cabs for a smooth and relaxing journey to any outstation destination from Pune."
  },
  {
    "WhyChooseheading": "Experienced Drivers for Long-Distance Travel",
    "WhyChoosedescription": "Our professional drivers are experienced in long-distance routes, ensuring safe, timely, and hassle-free outstation travel from Pune."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Sanavi Travels provides clear and upfront pricing for Pune to outstation cab packages, including fuel, tolls, and driver allowances."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our support team is available round the clock to assist with bookings, route planning, and travel-related inquiries."
  },
  {
    "WhyChooseheading": "Flexible Travel Plans",
    "WhyChoosedescription": "Choose from one-way, round-trip, or customized outstation cab packages based on your travel requirements and schedule."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All cabs are thoroughly cleaned and sanitized before every trip to ensure a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable service, making Sanavi Travels a trusted choice for Pune to outstation cab packages."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide Pune to outstation cab packages?',
    answer: 'Yes, Sanavi Travels offers comfortable and reliable cab packages from Pune to various outstation destinations.'
  },
  {
    question: 'How can I book an outstation cab from Pune?',
    answer: 'You can book online through our website or by contacting our 24x7 customer support team for assistance.'
  },
  {
    question: 'What types of cabs are available for outstation trips?',
    answer: 'Sanavi Travels offers sedans, SUVs, and premium cars suitable for long-distance travel.'
  },
  {
    question: 'Are drivers experienced for outstation routes?',
    answer: 'Yes, our drivers are licensed, professional, and familiar with long-distance routes to ensure safe travel.'
  },
  {
    question: 'Can I choose custom pickup and drop-off locations?',
    answer: 'Absolutely. You can select your preferred pickup in Pune and drop-off at any outstation destination.'
  },
  {
    question: 'Is the outstation cab service available 24x7?',
    answer: 'Yes, Sanavi Travels offers round-the-clock cab services for outstation travel.'
  },
  {
    question: 'Are safety and hygiene protocols followed?',
    answer: 'All cabs are sanitized regularly, and our drivers follow strict safety and hygiene guidelines.'
  },
  {
    question: 'What payment options are available for outstation cab bookings?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate payments.'
  },
  {
    question: 'Is customer support available during the journey?',
    answer: 'Yes, our 24x7 customer support team is available throughout your Pune to outstation cab journey.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rajesh Patil',
    feedback: 'Booked an outstation cab from Pune with Sanavi Travels. Smooth ride, comfortable cab, and professional driver made our trip hassle-free.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Priya Deshmukh',
    feedback: 'Excellent service! The cab was clean, air-conditioned, and the driver was punctual and courteous. Highly recommended for long trips.',
    rating: 5
  }
];
















































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];












const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Outstation Cabs Package - Sanavi Travels",
  "description": "Book Pune to Outstation cabs package with Sanavi Travels. AC and luxury cabs for family trips, corporate travel, long-distance journeys, one-way or round-trip travel, tourist trips, and comfortable chauffeur-driven outstation service.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "1600"
  }
};




  return (
    <div>
<Helmet>
  <title>
    Pune to Outstation Cabs Package | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Hire AC and luxury cabs from Pune for outstation travel with Sanavi Travels. Ideal for family trips, corporate journeys, long-distance travel, one-way or round trips, and safe chauffeur-driven service."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/55.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetooutstationcabspackages;